import { Box } from "@chakra-ui/react"
import { useState } from "react"
import CreateOrSelectResource from "./CreateOrSelectResource"
import PathCreatorForm, { OnComplete } from "./PathCreatorForm"
import { PathCreatorRawValues } from "./state"

type PathCreatorFlowProps = {
  targetUserId: number
  onComplete?: OnComplete
  initialValue?: PathCreatorRawValues
  // Whether the PathCreatorForm inputs should auto show their related tooltip when
  // user focuses the input.
  autoShowTips?: boolean
}

function PathCreatorFlow({
  targetUserId,
  onComplete,
  initialValue,
  autoShowTips
}: PathCreatorFlowProps) {
  // Handle both the initialValue prop and state, which could be updated by
  // the CreateOrSelectResource component.
  // Using null value to indicate user is explicitly choosing to select existing resource,
  // rather than create a new one.
  const [initialFormValue, setInitialFormValue] = useState<
    PathCreatorRawValues | undefined
  >(initialValue)

  return (
    <Box className="PathCreatorFlow" pos="relative" w="100%">
      {initialFormValue ? (
        <PathCreatorForm
          targetUserId={targetUserId}
          onComplete={onComplete}
          initialValue={initialFormValue}
          autoShowTips={autoShowTips}
        />
      ) : (
        <CreateOrSelectResource onSelect={setInitialFormValue} />
      )}
    </Box>
  )
}

export default PathCreatorFlow
